module.exports = __webpack_public_path__ + "img/CM-BS-24-CJDR-Established.476b962b.jpg";